import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import MessageCircle from "../../assets/IconMessage.svg"

import ContactInfo from './ContactInfo';
import ContactForm from './ContactForm';

import css from './ContactUsPage.module.css';

export const ContactUsPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const title = intl.formatMessage({ id: 'ContactUsPage.title' });
  const description = intl.formatMessage({ id: 'ContactUsPage.description' });

  return (
    <Page title={title} description={description} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
        mainColumnClassName={css.layoutWrapperMain}
      >
        <div className={css.root}>
          {/* Hero Section */}
          <section className={css.heroSection}>
            <div className={css.heroContainer}>
              <div className={css.heroContent}>
                <div className={css.heroIcon}>
                  <img src={MessageCircle} alt="Contact Us" className={css.iconSvg} />
                </div>
                <h1 className={css.heroTitle}>
                  <FormattedMessage id="ContactUsPage.heroTitle" />
                </h1>
                <p className={css.heroDescription}>
                  <FormattedMessage id="ContactUsPage.heroDescription" />
                </p>
              </div>
            </div>
          </section>

          {/* Main Content */}
          <section className={css.contentSection}>
            <div className={css.contentContainer}>
              <div className={css.contentInner}>
                {/* Contact Methods */}
                <div className={css.contactMethodsSection}>
                  <h2 className={css.sectionTitle}>
                    <FormattedMessage id="ContactUsPage.getInTouchTitle" />
                  </h2>
                  <ContactInfo />
                </div>

                {/* Contact Form */}
                <div className={css.contactFormSection}>
                  <ContactForm />
                </div>
              </div>
            </div>
          </section>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

ContactUsPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: state.ui?.scrollingDisabled || false,
  };
};

const ContactUsPage = compose(
  injectIntl,
  connect(mapStateToProps)
)(ContactUsPageComponent);

export default ContactUsPage;
